import React from 'react';
import {
  Controller,
  ControllerProps,
  UseFormReturn,
  UseFormStateReturn,
  ControllerFieldState,
  ControllerRenderProps,
  FieldValues,
  FieldError,
  get,
} from 'react-hook-form';

export type FieldControllerProps = Omit<ControllerProps, 'render' | 'control'> & {
  mapper?: (v: React.ChangeEvent<HTMLInputElement>) => string;
  mask?: (value: string) => string;
  form: UseFormReturn;

  render: ({
    field,
    fieldState,
    formState,
    error,
    onChange,
  }: {
    field: ControllerRenderProps;
    fieldState: ControllerFieldState;
    formState: UseFormStateReturn<FieldValues>;
    error?: FieldError;
    onChange: (v: React.ChangeEvent<HTMLInputElement>) => void;
    onValueTransform: (value: string) => string;
  }) => React.ReactElement;
};

export const FieldController = ({
  mapper,
  mask,
  render,
  form,
  ...other
}: FieldControllerProps) => (
  <Controller
    control={form.control}
    {...other}
    render={({ field, formState, fieldState }) => {
      const onValueTransform = (value: any) => (!!mask ? mask(value) : value);

      const onChange = (v: React.ChangeEvent<HTMLInputElement>) => {
        let result = v;
        if (mapper) {
          result.target.value = mapper(v);
        }

        field.onChange(result);
        form.clearErrors(other.name);

        return result;
      };

      const error = get(formState.errors, other.name);

      return render({
        field,
        fieldState,
        formState,
        error,
        onChange,
        onValueTransform,
      });
    }}
  />
);

export default FieldController;
